export default __webpack_public_path__ + "static/media/basketballlogo.9e5af296.png";